import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Sparkles, ArrowLeft, ChevronDown, Search, MessageSquare, CreditCard, User, Shield, Cog, Star } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

interface FaqItem {
  q: string
  a: string
  category: string
}

const FAQ_DATA: FaqItem[] = [
  // Регистрация и аккаунт
  { category: 'Аккаунт', q: 'Как зарегистрироваться?', a: 'Нажмите «Зарегистрироваться» на главной странице, введите email, имя и пароль. После регистрации на указанный email придёт письмо с подтверждением. Подтвердите email, чтобы получить бонусные токены.' },
  { category: 'Аккаунт', q: 'Не приходит письмо с подтверждением email', a: 'Проверьте папку «Спам» или «Промоакции». Если письма нет — нажмите «Отправить ещё раз» на странице регистрации или в профиле. Письмо приходит в течение нескольких минут.' },
  { category: 'Аккаунт', q: 'Я забыл пароль. Что делать?', a: 'На странице входа нажмите «Забыли пароль?». Введите email, и мы отправим инструкции по сбросу. Ссылка действует 1 час.' },
  { category: 'Аккаунт', q: 'Как изменить имя или аватар?', a: 'Зайдите в Профиль (иконка в правом верхнем углу → «Профиль»). Там можно изменить имя и загрузить аватар.' },
  { category: 'Аккаунт', q: 'Можно ли удалить аккаунт?', a: 'Да. Напишите на support@chat-neuro.ru с вашего зарегистрированного email. Аккаунт будет удалён в течение 30 дней вместе со всеми данными.' },

  // Токены и оплата
  { category: 'Токены', q: 'Что такое CN-токены?', a: 'CN-токены — внутренняя валюта Chat-Neuro.ru. Они тратятся на запросы к платным AI-моделям. Бесплатные модели (TypeGPT) доступны безлимитно и не расходуют токены.' },
  { category: 'Токены', q: 'Как пополнить баланс?', a: 'В профиле нажмите «Пополнить баланс». Выберите один из тарифов и оплатите через ЮKassa. После оплаты токены зачисляются автоматически.' },
  { category: 'Токены', q: 'Сколько токенов стоит запрос?', a: 'Стоимость зависит от модели. Бесплатные модели — 0 токенов. Платные: чат ~0.1-3 токена за ответ, изображения ~5-20 токенов, видео ~15-60 токенов. Точная цена отображается перед генерацией.' },
  { category: 'Токены', q: 'Токены сгорают?', a: 'Нет, токены не сгорают. Вы можете использовать их в любое время. Исключение: при удалении или блокировке аккаунта остаток не возвращается.' },
  { category: 'Токены', q: 'Можно ли вернуть деньги за токены?', a: 'Токены являются авансовым платежом за будущее использование сервиса. Возврат возможен только в случаях, предусмотренных законодательством РФ. По индивидуальным вопросам — пишите в поддержку.' },
  { category: 'Токены', q: 'Откуда берутся звёзды?', a: 'Звёзды даются за подтверждение email и специальные акции. Они расходуются на генерацию изображений, видео и музыки. Звёзды не эквивалентны токенам.' },
  { category: 'Токены', q: 'Что такое бесплатные модели?', a: 'Бесплатные модели (провайдер TypeGPT) доступны всем пользователям без ограничений. Они не тратят токены. Всего доступно 9 бесплатных моделей, включая GPT, Claude, Gemini и DeepSeek.' },

  // Модели и сервисы
  { category: 'Сервисы', q: 'Какие AI-модели доступны?', a: 'У нас 30+ моделей: ChatGPT (GPT-5.x), Claude, Gemini, DeepSeek, Grok для чата; Flux, Recraft, Seedream, Stable Diffusion для изображений; Gen-3, Kling, Haiper для видео; Suno, Udio для музыки. Полный список — на странице «AI-модели».' },
  { category: 'Сервисы', q: 'Почему модель недоступна?', a: 'Модель может быть временно отключена из-за технических работ, проблем с API провайдера или планового обслуживания. Проверьте список моделей — статус отображается зелёным (работает) или красным (недоступна).' },
  { category: 'Сервисы', q: 'AI отвечает неправильно или галлюцинирует', a: 'AI-модели могут ошибаться. Попробуйте: 1) переформулировать запрос; 2) выбрать другую модель; 3) добавить контекст. Помните: AI не даёт профессиональных консультаций (медицинских, юридических, финансовых).' },
  { category: 'Сервисы', q: 'Как понять, что контент создан AI?', a: 'Контент, сгенерированный нашим сервисом, может содержать маркировку. На каждой странице генерации есть соответствующее уведомление. Рекомендуем указывать, что контент создан с помощью AI, при публикации.' },
  { category: 'Сервисы', q: 'Есть ли веб-поиск в чате?', a: 'Да, в чате можно включить веб-поиск. Нажмите кнопку «Поиск в интернете» перед отправкой сообщения — AI найдёт актуальную информацию и укажет источники.' },
  { category: 'Сервисы', q: 'Как работает генерация изображений?', a: 'Выберите модель, опишите что хотите увидеть (на русском или английском), настройте соотношение сторон и количество вариантов. Изображения генерируются за 10-30 секунд.' },
  { category: 'Сервисы', q: 'Как скачать сгенерированное изображение/видео?', a: 'В галерее нажмите на изображение или видео — откроется модальное окно с кнопкой «Скачать». Все ваши генерации сохраняются в галерее.' },

  // Технические вопросы
  { category: 'Техника', q: 'Какие браузеры поддерживаются?', a: 'Сайт работает в современных браузерах: Chrome, Firefox, Safari, Edge, Яндекс.Браузер. Рекомендуем использовать последние версии.' },
  { category: 'Техника', q: 'Почему сайт тормозит?', a: 'Возможные причины: 1) медленное интернет-соединение; 2) загруженность AI-модели (попробуйте другую); 3) много открытых вкладок. Попробуйте обновить страницу (Ctrl+Shift+R).' },
  { category: 'Техника', q: 'Как работает голосовой ввод?', a: 'Голосовой ввод использует Web Speech API вашего браузера. Нажмите на иконку микрофона в поле ввода и произнесите запрос. Доступно в Chrome и Safari.' },
  { category: 'Техника', q: 'Ранее загруженные файлы сохраняются?', a: 'Файлы, прикреплённые к чату, не сохраняются после закрытия диалога. Сохраняйте важные файлы локально.' },

  // Безопасность
  { category: 'Безопасность', q: 'Мои данные в безопасности?', a: 'Да. Пароли хранятся в зашифрованном виде (bcrypt). Все соединения — по HTTPS. API-ключи провайдеров зашифрованы (AES-256). Мы не передаём ваши данные третьим лицам.' },
  { category: 'Безопасность', q: 'Кто видит мои запросы?', a: 'Ваши запросы видны только вам. Мы не просматриваем историю пользователей. Технически запросы передаются AI-провайдерам для выполнения генерации, но без ваших персональных данных.' },
  { category: 'Безопасность', q: 'Как защитить аккаунт?', a: 'Используйте сложный пароль (не менее 8 символов, буквы + цифры). Не сообщайте пароль никому. Не используйте один пароль на разных сайтах.' },
  { category: 'Безопасность', q: 'Что делать, если кто-то получил доступ к аккаунту?', a: 'Немедленно смените пароль через форму восстановления. Если не можете войти — напишите в поддержку support@chat-neuro.ru.' },
]

const CATEGORY_ICONS: Record<string, React.ReactNode> = {
  'Аккаунт': <User className="w-4 h-4" />,
  'Токены': <CreditCard className="w-4 h-4" />,
  'Сервисы': <Star className="w-4 h-4" />,
  'Техника': <Cog className="w-4 h-4" />,
  'Безопасность': <Shield className="w-4 h-4" />,
}

export default function FaqPage() {
  const { user } = useAuthStore()
  const [search, setSearch] = useState('')
  const [openItems, setOpenItems] = useState<Set<number>>(new Set())

  // Группировка по категориям
  const grouped: Record<string, FaqItem[]> = {}
  FAQ_DATA.forEach(item => {
    if (!grouped[item.category]) grouped[item.category] = []
    grouped[item.category].push(item)
  })

  // Фильтр по поиску
  const filtered = Object.entries(grouped).map(([cat, items]) => [
    cat,
    search
      ? items.filter(i => i.q.toLowerCase().includes(search.toLowerCase()) || i.a.toLowerCase().includes(search.toLowerCase()))
      : items,
  ] as [string, FaqItem[]]).filter(([, items]) => items.length > 0)

  const toggle = (idx: number) => {
    setOpenItems(prev => {
      const next = new Set(prev)
      if (next.has(idx)) next.delete(idx)
      else next.add(idx)
      return next
    })
  }

  return (
    <div>

      <div className="max-w-3xl mx-auto px-4 pt-4 pb-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-2">
          <Link to="/" className="p-2 rounded-xl glass-hover text-gray-400 hover:text-white transition-all whitespace-nowrap">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold gradient-text">Часто задаваемые вопросы</h1>
              <p className="text-xs text-gray-500">
                Всё, что вы хотели знать о Chat-Neuro.ru
              </p>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="relative mt-6 mb-8">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <input
            type="text"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setOpenItems(new Set()) }}
            placeholder="Поиск по вопросам..."
            className="input-field pl-9"
          />
        </div>

        {/* FAQ by category */}
        <div className="space-y-6">
          {filtered.map(([category, items]) => (
            <div key={category}>
              <h2 className="text-base font-bold text-white flex items-center gap-2 mb-3">
                <span className="text-indigo-400">{CATEGORY_ICONS[category] || <MessageSquare className="w-4 h-4" />}</span>
                {category}
                <span className="text-xs text-gray-500 font-normal">({items.length})</span>
              </h2>
              <div className="glass-card divide-y divide-white/5">
                {items.map((item, i) => {
                  // Глобальный индекс для toggle
                  const globalIdx = FAQ_DATA.indexOf(item)
                  const isOpen = openItems.has(globalIdx)
                  return (
                    <div key={globalIdx}>
                      <button
                        onClick={() => toggle(globalIdx)}
                        className="w-full flex items-center justify-between p-4 text-left hover:bg-white/[0.02] transition-colors"
                      >
                        <span className="text-sm text-gray-200 font-medium">{item.q}</span>
                        <ChevronDown className={`w-4 h-4 text-gray-500 shrink-0 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                      </button>
                      {isOpen && (
                        <div className="px-4 pb-4 text-xs text-gray-400 leading-relaxed max-w-none [&_a]:text-indigo-400 [&_a]:hover:text-indigo-300">
                          {item.a}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-10 glass-card p-6 text-center">
          <p className="text-sm text-gray-300 mb-2">Не нашли ответа?</p>
          <Link
            to="/support"
            className="gradient-btn inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm"
          >
            <MessageSquare className="w-4 h-4" />
            Написать в поддержку
          </Link>
        </div>
      </div>


    </div>
  )
}
